import React, { useEffect, useState } from "react";
import {BASE_TITLE, DELIMITER, PageProps} from "src/components/App";
import {useSelector} from "react-redux";
import {CombineReducerState} from "src/combineReducers";
import {Grid} from "@mui/material";
import AccordianTitle from "src/components/display/AccordianTitle";
import DateRangeForm from "src/components/forms/DateRangeForm";
import {routes} from "src/data/Routes";
import MetricCard from "src/components/display/MetricCard";
import {HOVER_METRICS_BANNER_CONTENT} from "src/constants/ServiceConstants";

// Type definitions for Hover Tool Metrics
interface HoverToolMetrics {
    reportsGenerated: number;
    uniqueUsers: number;
    uniqueTeams: number;
}

interface HoverToolApiData {
    metrics: HoverToolMetrics;
}

interface ApiResponseWrapper<T> {
    data: T;
    error: boolean;
    status: number;
    apiErrorMessage: string | null;
}

type HoverToolApiResponse = ApiResponseWrapper<HoverToolApiData>;

const HoverToolMetrics = (props: PageProps) => {

    const PAGE_TITLE = props.title;
    document.title = PAGE_TITLE + DELIMITER + BASE_TITLE;
    const baseUrl = useSelector((state: CombineReducerState) => state.navbar.baseUrl);

    let [response, setResponse] = useState<HoverToolApiResponse>({} as HoverToolApiResponse);
    let [metricData, setMetricData] = useState<HoverToolApiResponse>({} as HoverToolApiResponse);
    let [dayDifference, setDayDifference] = useState<number>();

    const metricsConfig = [
        { title: "Number of reports generated successfully", metric: metricData?.data?.metrics?.reportsGenerated ?? 0 },
        { title: "Number of unique users", metric: metricData?.data?.metrics?.uniqueUsers ?? 0 },
        { title: "Number of unique teams", metric: metricData?.data?.metrics?.uniqueTeams ?? 0 },
    ];

    useEffect(() => {
        setMetricData({...response});
    }, [response]);

    return (
        <Grid container>
            <Grid container justifyContent={"space-between"} marginBottom={4}>
                <Grid xs={7} >
                    <AccordianTitle title={"Hover Tool Metrics"} cardContent={HOVER_METRICS_BANNER_CONTENT} elevation={3} />
                </Grid>
            </Grid>

            <Grid container justifyContent={"space-between"} alignItems={"center"} marginBottom={4} >
                <Grid xs={4}>
                    <DateRangeForm handler={setResponse}
                                   url={baseUrl + routes.hoverToolMetrics.hoverToolMetrics}
                                   dayDifference={setDayDifference} operation={"getMetrics"}
                    />
                </Grid>

                {metricsConfig.map(({ title, metric }, index) => (
                    <Grid key={index} xs={3}>
                        <MetricCard title={title} metric={metric} />
                    </Grid>
                ))}
            </Grid>
        </Grid>
    );
}

export default HoverToolMetrics;
